import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { FLUSH, persistStore, PURGE } from "redux-persist"; // Import persistStore

const isProdLike = process.env.REACT_APP_ENV === "production";

const enableLogger =
  !isProdLike &&
  process.env.REACT_APP_ENABLE_LOGS === "true";

const enableReduxDevTools = !isProdLike;

const store = configureStore({
  reducer: rootReducer,
  devTools: enableReduxDevTools,
  middleware: (getDefaultMiddleware) => {
    if (enableLogger) {
      // require() keeps redux-logger out of the production bundle entirely
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const logger = require("redux-logger").default;
      return getDefaultMiddleware({
        serializableCheck: false,
      }).concat(logger);
    }
    return getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [PURGE, FLUSH],
      },
    });
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

const persistor = persistStore(store); // Create the persistor instance

export { persistor };  // Named export for persistor
export default store;  // Default export for store